import {API} from "./API";
import {Folder} from "../models/Folder";

export class FoldersAPI extends API<Folder> {

	constructor () {
		super("folders");
    }
}
